import React from 'react'
import { useDraggableSheet } from '../../../helpers/hooks';
import './Contribute.scss';
import Icon from '../Icon/Icon';
import { getUserDisplayName } from '../../../helpers/userDisplayName';

const Contribute = ({ creation, onClose, onSubmit }) => {

    const {
        // dragOffset,
        // dragging,
        sheetStyle,
        overlayHandlers
    } = useDraggableSheet({ onClose });

    return (
        <div
            className="about-creator "
            {...overlayHandlers}
        >
            <div
                className={`sheet p-24 d-flex f-column aic jcc`}
                style={{ ...sheetStyle }}
                onClick={(e) => e.stopPropagation()}
            >
                <Icon alias="contribute" color="#FF3232" width={80} className="mt-24" />
                <p className="fs-sm2 fw-bold mt-24 mb-40 ta-center">This creation is free, would you like to contribute?</p>
                <button
                    className="btn red-btn btn-full aic jcc fw-extra-bold mb-24"
                    style={{ height: '64px' }}
                    onClick={onSubmit}
                >
                    CONTRIBURTE TO {getUserDisplayName(creation.users)}
                </button>
                <p className="fs-xxs fg-dark fw-bold mb-16 mt-0 c-pointer td-underline" onClick={onClose}>CANCEL</p>
            </div>
        </div>
    )
}

export default Contribute